class ScShippingEstimate extends HTMLElement {
  connectedCallback() {
    this.render();
    document.addEventListener('cart:update', this.render);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.render);
  }

  render = () => {
    const shopifyCurrency = window.Shopify?.currency;
    const currency = this.dataset.presentmentCurrency;
    const baseCurrency = this.dataset.baseCurrency;
    const rate = Number(shopifyCurrency?.rate);
    const baseRate = Number(this.dataset.baseRate);
    const baseThreshold = Number(this.dataset.baseThreshold);

    if (
      baseCurrency !== 'EUR' ||
      !['CAD', 'CHF'].includes(currency) ||
      shopifyCurrency?.active !== currency ||
      !Number.isFinite(rate) ||
      rate <= 0 ||
      !Number.isFinite(baseRate) ||
      !Number.isFinite(baseThreshold)
    ) {
      this.hidden = true;
      this.textContent = '';
      return;
    }

    const formatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang, {
      style: 'currency',
      currency,
      currencyDisplay: 'code',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const shippingEstimate = formatter.format(baseRate * rate);
    const thresholdEstimate = formatter.format(baseThreshold * rate);

    this.textContent =
      this.dataset.language === 'fr'
        ? ` Estimation actuelle : ${shippingEstimate} ; seuil indicatif : ${thresholdEstimate}. Estimation non garantie selon le taux actuel de la boutique ; l’arrondi et le montant final peuvent différer au paiement.`
        : ` Current estimate: ${shippingEstimate}; indicative threshold: ${thresholdEstimate}. Non-guaranteed estimate using the store’s current rate; checkout rounding and the final charge may differ.`;
    this.hidden = false;
  };
}

if (!customElements.get('sc-shipping-estimate')) {
  customElements.define('sc-shipping-estimate', ScShippingEstimate);
}
